import { ReactNode } from "react";
import QuizStep from "@/icons/ui/quiz-step.svg";
import ReceiveTreatmentStep from "@/icons/ui/receive-treatment-step.svg";
import StartTreatmentStep from "@/icons/ui/start-treatment-step.svg";

type Step = {
    imageUrl: string;
    imageAlt: string;
    icon: ReactNode;
    title: string;
    description: string;
};

export const STEPS: Step[] = [
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790099226/new_design/Image_snnxov.webp",
        imageAlt: "Inner Balance health quiz on a phone",
        icon: <QuizStep className="w-[110px] h-[110px] md:w-[136px] md:h-[136px]" />,
        title: "Quiz Intake",
        description: "You share your symptoms, history and goals.",
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790099226/new_design/Image_1_sj42vs.webp",
        imageAlt: "Prescription treatment delivered to your door",
        icon: <ReceiveTreatmentStep className="w-[110px] h-[110px] md:w-[136px] md:h-[136px]" />,
        title: "Clinical approval for treatment delivery",
        description: "A licensed clinician evaluates and determines next steps. Once approved, prescription is delivered.",
    },
    {
        imageUrl: "https://res.cloudinary.com/dirscuuhp/image/upload/v1790099226/new_design/Image_2_ke1wiu.webp",
        imageAlt: "Ongoing support from the Inner Balance care team",
        icon: <StartTreatmentStep className="w-[110px] h-[110px] md:w-[136px] md:h-[136px]" />,
        title: "Start treatment and get ongoing support",
        description: "Our care team guides you with check-ins and recommendations for optimal results.",
    },
];
